import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import './DeleteConfirmation.css';

const DeleteConfirmation = ({ open, onClose, msg, msg2, hideCancel = false }) => {
  const handleYes = () => {
    onClose('confirm');
  };

  const handleNo = () => {
    onClose('cancel');
  };

  return (
    <Dialog open={open} onClose={handleNo}>
      <DialogContent>
        <div className="deletePop">
          {!hideCancel && (
            <IconButton onClick={handleNo} style={{ position: 'absolute', top: 8, right: 8 }}>
              <CancelIcon />
            </IconButton>
          )}
          <h2>{msg}</h2>
          {msg2 && <p>{msg2}</p>}
          <DialogActions style={{ justifyContent: 'center' }}>
            <Button onClick={handleYes} color="primary" variant="contained">
              Yes
            </Button>
            <Button onClick={handleNo} color="error" variant="outlined">
              No
            </Button>
          </DialogActions>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteConfirmation;
